// extracted by css-extract-rspack-plugin
export default {"cls1":"report_modal-cls1_Zz9","cls2":"report_modal-cls2_j0W report_modal-cls1_Zz9"};